import { render, staticRenderFns } from "./SaleDocumentsTab.vue?vue&type=template&id=7e58e8a5&scoped=true&"
import script from "./SaleDocumentsTab.vue?vue&type=script&lang=js&"
export * from "./SaleDocumentsTab.vue?vue&type=script&lang=js&"
import style0 from "./SaleDocumentsTab.vue?vue&type=style&index=0&id=7e58e8a5&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e58e8a5",
  null
  
)

export default component.exports